import styled from "styled-components";

// Mesmo visual do card que morava em Configuracoes (agora no Perfil).
export const Caixa = styled.section`
  min-width: 0;
  border-radius: 6px;
  background: #FCFEFC;
  box-shadow: 0px 2px 3px 0px rgba(36, 36, 36, 0.10);
  padding: 24px 28px;

  margin-top: 8px;
  .top{
    display: flex; align-items: center; gap: 9px;
    border-bottom: 1px solid #CFCFCF; padding-bottom: 8px;
    img{ width: 24px; }
    h3{ margin: 0; font-size: 15px; font-weight: 600; line-height: 150%; }
  }
  .item{
    display: flex; flex-direction: column; padding-bottom: 6px; border-bottom: 1px solid #CFCFCF;
    &:last-child{ border-bottom: 0; }
    label{ margin-top: 12px; color: #6B6E70; font-size: 14px; font-weight: 500; }
    .linha{ display: flex; align-items: center; justify-content: space-between; gap: 8px; }
    .valor{ color: #4D4F50; font-size: 14px; font-weight: 500; margin-top: 6px; overflow-wrap: anywhere; min-height: 21px; }
    .editar{ background: none !important; border: 0 !important; padding: 4px !important; margin: 0 !important; width: auto !important; height: auto !important; cursor: pointer; display: inline-flex; flex: none; img{ width: 18px; } &:focus-visible{ outline: 2px solid var(--primary-color); border-radius: 4px; } }
  }
`;

export const Acoes = styled.section`
  display: flex; flex-direction: column; gap: 14px; margin-top: 18px;
  button{
    width: 100% !important; height: 40px !important; margin: 0 !important; border-radius: 6px;
    cursor: pointer; font-weight: 600; font-family: inherit;
    &:focus-visible{ outline: 2px solid var(--primary-color); outline-offset: 2px; }
  }
  && .acao-sair{ border: 1px solid #4D4F50 !important; background: transparent !important; color: #4D4F50 !important; }
  && .acao-deletar{ border: 1px solid #D41A1A !important; background: #D41A1A !important; color: #fff !important; }
`;

// Os modais de editar dados eram renderizados dentro de Configuracoes (que definia o
// overlay). No Perfil perderam o estilo e apareciam soltos na pagina.
export const RaizModais = styled.div`
  .modal{
    z-index: 1000;
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(50,50,50,0.5);
    display: flex;
    align-items: center;
    justify-content: center;

    .content-modal{
      width: 450px;
      background-color: #fff;
      border-radius: 6px;
      padding: 18px 28px;

      .top{

        display: flex !important;;

        h3{
          font-size: 24px;
          font-style: normal;
          font-weight: 600;
          line-height: 120%;
        }

        img, button{
          width: 24px;
          height: 24px;
          background-color: transparent;
          border: none;
          cursor: pointer;
          margin: 0 !important ;
        }
      }

     

      .input-code{
          width: 44px;
          height: 52px;
          margin-right: 9px;
          text-align: center;
          background-color: #EDEDED;
          font-size: 15pt;
        }

        .resend-code{
          margin-top: 27px;
          font-size: 10px;
          max-width: 170px;
          height: 27px;
          font-weight: normal;
          background-color: #9A9A9A;

          :disabled{
            background-color: #FDFDFD;
            border: 1px solid #CFCFCF;
            color: #9A9A9A;
          }
        }

    }

    .form-group{
      button{
        margin-top: 10px !important ;
        margin-bottom: 5px !important;
      }
    }

  }
`;
